<template>
  <div class="office-preview-bridge">
    <template v-if="isIosSafari">
      <div class="office-preview-bridge__notice">
        {{ $t('На iPhone в Safari предпросмотр этого типа документа может не отображаться.') }}
      </div>
      <a
        class="office-preview-bridge__link"
        :href="fileUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $t('Открыть документ в новой вкладке') }}
      </a>
    </template>
    <VueDocPreview
      v-else
      :value="fileUrl"
      type="office"
    />
  </div>
</template>

<script>
import VueDocPreview from 'vue-doc-preview'

export default {
  name: 'OfficePreviewBridge',
  components: {
    VueDocPreview
  },
  props: {
    fileUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isIosSafari: false
    }
  },
  mounted() {
    const ua = window.navigator.userAgent || ''
    const isIphoneOrIpad = /iPhone|iPad|iPod/i.test(ua)
    const isSafari = /Safari/i.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS|YaBrowser/i.test(ua)
    this.isIosSafari = isIphoneOrIpad && isSafari
  }
}
</script>

<style scoped>
.office-preview-bridge__notice {
  margin-bottom: 12px;
}

.office-preview-bridge__link {
  text-decoration: underline;
}
</style>
